import React from 'react';

export const ModalLoader = () => (
  <div style={{ position: 'absolute', top: '50%' }} className="Modal-Loader">
    Loading
  </div>
);
